import React, { useEffect, useState } from 'react'
import { Button, notification } from 'antd'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'

import { addFooter, resetFooterStatus } from '~actions'
import { ResultModal } from '~components'
import { getCurrentUser } from '~context'
import { PageLayout } from '~stories'

import FooterForm, { EMPTY_FOOTER_PAYLOAD, getFooterValidationErrors } from '../FooterForm/FooterForm'

const PAGE_TITLE = 'Footer (MSG)'
const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.',
  REQUIRED_FIELDS: 'Please complete all required footer fields before saving.'
}

const NewFooter = ({ addFooter, isSaving, resetFooterStatus, updateMessage, updateStatus }) => {
  const [footer, setFooter] = useState(EMPTY_FOOTER_PAYLOAD)
  const { access_token: accessToken, userDetails: { isContentEditor } } = getCurrentUser()

  useEffect(() => {
    if (!updateStatus && updateMessage) {
      notification.error({ message: updateMessage })
      resetFooterStatus()
    }
  }, [resetFooterStatus, updateMessage, updateStatus])

  const onSubmit = () => {
    if (!isContentEditor) {
      notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
      return
    }

    const validationErrors = getFooterValidationErrors(footer)
    if (validationErrors.length > 0) {
      notification.error({
        description: validationErrors.slice(0, 3).join(' '),
        message: NOTIFICATION_MESSAGES.REQUIRED_FIELDS
      })
      return
    }

    addFooter(footer, accessToken)
  }

  const addAnother = (
    <Button
      onClick={() => {
        resetFooterStatus()
        setFooter(EMPTY_FOOTER_PAYLOAD)
      }}
      type='primary'
    >
      Add Another
    </Button>
  )

  const goToFooterListButton = (
    <Route key='listFooter' render={({ history }) => (
      <Button
        onClick={() => {
          resetFooterStatus()
          history.push('/footer')
        }}
        type='primary'
      >
        Go to Footer List
      </Button>
    )} />
  )

  return (
    <PageLayout extra={[<Button key='add_footer' loading={isSaving} onClick={onSubmit} type='primary'>Add</Button>]} title={PAGE_TITLE}>
      <FooterForm footer={footer} setFooter={setFooter} />
      {updateStatus && (
        <ResultModal
          actions={[goToFooterListButton, addAnother]}
          handleCancel={resetFooterStatus}
          status='success'
          title={updateMessage}
        />
      )}
    </PageLayout>
  )
}

NewFooter.propTypes = {
  addFooter: PropTypes.func,
  isSaving: PropTypes.bool,
  resetFooterStatus: PropTypes.func,
  updateMessage: PropTypes.string,
  updateStatus: PropTypes.bool
}

const mapStateToProps = ({ footer }) => ({
  isSaving: footer.isSaving,
  updateMessage: footer.message,
  updateStatus: footer.success
})

const mapDispatchToProps = {
  addFooter,
  resetFooterStatus
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewFooter)
